import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/brand/Logo";

export default function NotFound() {
  return (
    <div className="relative flex min-h-[80vh] items-center justify-center overflow-hidden px-6">
      <div className="bs-aurora pointer-events-none absolute inset-0 opacity-60" />
      <div className="relative text-center">
        <LogoMark size={64} className="mx-auto mb-6 animate-float" />
        <p className="font-mono text-sm font-semibold uppercase tracking-widest text-primary">Error 404</p>
        <h1 className="mt-3 font-display text-6xl font-black sm:text-8xl">Lost in space</h1>
        <p className="mx-auto mt-4 max-w-md text-muted-foreground">
          The page you're looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild className="rounded-full" data-testid="notfound-home">
            <Link to="/"><Home className="mr-2 h-4 w-4" /> Back home</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full">
            <Link to="/services"><ArrowLeft className="mr-2 h-4 w-4" /> Explore services</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
